export const AUTH_ROLE_KEY = 'villaAuthRole';
export const AUTH_ADMIN_FLAG_KEY = 'villaAuthenticated';

export const getAuthRole = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  const role = localStorage.getItem(AUTH_ROLE_KEY);
  if (role) {
    return role;
  }

  return localStorage.getItem(AUTH_ADMIN_FLAG_KEY) === 'true' ? 'admin' : '';
};

export const setAuthRole = (role) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!role) {
    localStorage.removeItem(AUTH_ROLE_KEY);
    localStorage.removeItem(AUTH_ADMIN_FLAG_KEY);
    window.dispatchEvent(new Event('villa-auth-changed'));
    return;
  }

  localStorage.setItem(AUTH_ROLE_KEY, role);

  if (role === 'admin') {
    localStorage.setItem(AUTH_ADMIN_FLAG_KEY, 'true');
  } else {
    localStorage.removeItem(AUTH_ADMIN_FLAG_KEY);
  }

  window.dispatchEvent(new Event('villa-auth-changed'));
};

export const clearAuth = () => {
  setAuthRole('');
};

export const subscribeAuthRole = (handler) => {
  const listener = () => handler(getAuthRole());

  window.addEventListener('storage', listener);
  window.addEventListener('villa-auth-changed', listener);

  return () => {
    window.removeEventListener('storage', listener);
    window.removeEventListener('villa-auth-changed', listener);
  };
};
